import React, { createContext, useState, useEffect } from "react";
import axiosPrivate from "../axios/axiosPrivate";
import useLoader from "../hooks/useLoader";
import useCart from "../hooks/useCart";
import axios from "axios";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { setPageLoading } = useLoader();
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const { cartData } = useCart();

  const getPhone = (phone) => {
    if (!phone) return null;
    return phone.replace(/\D/g, "").slice(-10);
  };

  useEffect(() => {
    const bootstrapAuth = async () => {
      // LOCALHOST
      // const storedToken = localStorage.getItem("hayd_auth");

      // if (!storedToken) {
      //   setAuthLoading(false);
      //   return;
      // }
      // setToken(storedToken);
      // LOCALHOST

      try {
        setPageLoading(true);
        const res = await axiosPrivate.get("/users/user-details");

        setUser(res?.data?.data?.customer);
      } catch (err) {
        // LOCALSTORAGE
        // localStorage.removeItem("hayd_auth");
        // setToken(null);
        // LOCALSTORAGE

        setUser(null);
      } finally {
        setPageLoading(false);
        setAuthLoading(false);
      }
    };

    bootstrapAuth();
  }, []);

  useEffect(() => {
    // AB CART DATA
    if (user && cartData?.items?.length > 0) {
      const callAbandoned = async () => {
        try {
          const name =
            user?.first_name || user?.addresses?.[0]?.first_name || "User";
          const phone =
            getPhone(user?.phone) || getPhone(user?.addresses?.[0]?.phone);
          const imageUrl = cartData?.items?.[0]?.image;
          const productImage = imageUrl?.startsWith("http")
            ? imageUrl
            : "https:" + imageUrl;

          await axios.post(
            "https://api.spurnow.com/profiles/2365/workflows/112171/webhooks",
            {
              phone: phone,
              name: name,
              first_product_image_url: productImage,
            }
          );
        } catch (error) {
          console.log(error);
        }
      };
      callAbandoned();
    }
    // AB CART DATA
  }, [cartData, user]);

  // LOCALSTORAGE
  // const login = (newToken, userData) => {
  // LOCALSTORAGE

  const login = async (userData) => {
    // LOCALSTORAGE
    // localStorage.setItem("hayd_auth", newToken);
    // setToken(newToken);
    // LOCALSTORAGE

    setUser(userData);
  };

  const logout = async () => {
    const res = await axiosPrivate.post("/users/user-logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ token, user, login, logout, authLoading, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};
